import type { AppState } from 'state/state.model';

import type { Kyc } from '../../../shared/kyc/kyc.model';

function selectKycState(state: AppState, tabId: string): Kyc {
  return state.secondaryMarket.cpOrder.referential.kyc[tabId];
}

export function getKycStatusScore(appState: AppState, tabId: string) {
  const state = selectKycState(appState, tabId);
  return state?.data?.score;
}

export function getKycStatusDetails(appState: AppState, tabId: string) {
  const state = selectKycState(appState, tabId);
  return state?.data?.details;
}
